import Input from "app/components/Input";
import { ITicketFormData } from "app/containers/Features/containers/Boards/containers/Tickets/types";
import { findFieldGroupByCategory } from "app/containers/Features/containers/Boards/helpers";
import {
  FieldCategoryTypeEnum,
  ITicketTypes,
} from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import { IWorkspaceProjects, IWorkspaceTeams } from "app/types";
import React, { useMemo } from "react";
import { getFieldRenderers } from "./fieldRenderers";
import { useContextFields } from "./useContextFields";

interface Props {
  form: ITicketFormData;
  ticketTypes: ITicketTypes[];
  projectId: string;
  createTicketForHome: boolean;
  selectedTeam: IWorkspaceTeams;
  selectedProject: IWorkspaceProjects;
  isAddEpicModal?: boolean;
}

const ContextFields = (props: Props) => {
  const {
    form,
    ticketTypes,
    projectId,
    selectedTeam,
    selectedProject,
    isAddEpicModal = false,
  } = props;

  const { left, right, setValue } = useContextFields(props);

  const renderers = getFieldRenderers({
    form,
    setValue,
    ticketTypes,
    projectId,
    selectedTeam,
    selectedProject,
    isAddEpicModal,
  });

  const selectedType = useMemo(
    () => ticketTypes.find((t) => t._id === form.type),
    [ticketTypes, form.type],
  );

  const contextFields = useMemo(
    () =>
      findFieldGroupByCategory(
        selectedType?.ticketTypeFields || [],
        FieldCategoryTypeEnum.CONTEXT_FIELDS,
      ),
    [selectedType],
  );
  const showDescription = contextFields.some(
    (f) => f.fieldToolTip === "ticketDescription",
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-x-6 gap-y-1">
        {[left, right].map((col, idx) => (
          <div key={idx} className="flex flex-col gap-1">
            {col.map((f) => renderers[f.fieldToolTip] ?? null)}
          </div>
        ))}
      </div>

      {showDescription && (
        <Input
          placeholder="Enter ticket description..."
          id="task-description"
          inputClassName="!h-[42px]"
          name="description.content"
          value={form.description.content}
          onChange={(e) => {
            setValue("description", {
              ...form.description,
              rawContent: e.target.value,
              content: e.target.value,
            });
          }}
        />
      )}
    </div>
  );
};

export default ContextFields;
